import { MoveLeft, MoveRight } from 'lucide-react';

import { Button } from '~/components/shadcn/button';
import { cn } from '~/utils/cn';
import { formatDate } from '~/utils/format.ts';
import { useHints } from '~/utils/start-client-hints.tsx';

const CalendarHeader = ({
	currentMonth,
	setCurrentMonth,
}: {
	currentMonth: Date;
	setCurrentMonth: React.Dispatch<React.SetStateAction<Date>>;
}) => {
	const { locale } = useHints();

	const handlePreviousMonthClick = () => {
		setCurrentMonth((previousMonth) => {
			const nextMonth = new Date(previousMonth.getTime());
			nextMonth.setMonth(nextMonth.getMonth() - 1);
			return nextMonth;
		});
	};

	const handleNextMonthClick = () => {
		setCurrentMonth((previousMonth) => {
			const nextMonth = new Date(previousMonth.getTime());
			nextMonth.setMonth(nextMonth.getMonth() + 1);
			return nextMonth;
		});
	};

	return (
		<nav
			className={cn(
				'col-span-3 flex w-full flex-row justify-center px-8 pt-4 pb-6 md:pb-8 lg:pb-10',
				'text-foreground',
			)}
		>
			<div className="mr-auto flex">
				<Button
					className={cn('flex h-full px-2 font-normal', 'transition-colors duration-300')}
					key="previous-month"
					onClick={handlePreviousMonthClick}
					variant="ghost"
				>
					<MoveLeft size={24} />
				</Button>
			</div>
			<div className="flex items-center justify-center">
				<h2 className={cn('font-sans text-foreground text-xl')}>
					{formatDate(currentMonth, locale, { month: 'long', year: 'numeric' })}
				</h2>
			</div>
			<div className="ml-auto flex">
				<Button
					className={cn('flex h-full px-2 font-normal', 'transition-colors duration-300')}
					key="next-month"
					onClick={handleNextMonthClick}
					variant="ghost"
				>
					<MoveRight size={24} />
				</Button>
			</div>
		</nav>
	);
};

export default CalendarHeader;
